import type { BenefitStatus, VoucherStatus } from '../types'

type StatusType = BenefitStatus | VoucherStatus

const STATUS_STYLES: Record<StatusType, string> = {
  active: 'bg-green-100 text-green-800',
  used: 'bg-blue-100 text-blue-800',
  expired: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-red-100 text-red-800',
  pending: 'bg-yellow-100 text-yellow-800',
  redeemed: 'bg-green-100 text-green-800',
}

const STATUS_LABELS: Record<StatusType, string> = {
  active: 'Activo',
  used: 'Usado',
  expired: 'Expirado',
  cancelled: 'Cancelado',
  pending: 'Pendiente',
  redeemed: 'Canjeado',
}

interface BenefitStatusBadgeProps {
  status: StatusType
  className?: string
}

export function BenefitStatusBadge({ status, className = '' }: BenefitStatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-600'
  const label = STATUS_LABELS[status] ?? status

  return (
    <span
      className={`inline-block px-2 py-1 rounded text-xs font-medium ${style} ${className}`}
    >
      {label}
    </span>
  )
}
